module.exports = __webpack_public_path__ + "img/cancel-pickup.7df82633.svg";